module.exports = __webpack_public_path__ + "img/qrec_scheme-20-15.b901c1fc.png";